// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Layout & Containers */

.DriverLogs_filterPanel__0XBo2 {
  background-color: #fff;
  padding: 1.25rem 1.5rem;
  border-radius: 0.5rem;
  margin-bottom: 1.5rem;
  border: 1px solid #f0f0f0;
}

.DriverLogs_filterTitle__jooGa {
  font-size: 1rem;
  font-weight: 600;
  color: var(--darkGray);
  margin-bottom: 1rem;
}

.DriverLogs_filterLabel__CKJPl {
  margin-bottom: 0.375rem;
  font-weight: 500;
  color: var(--gray);
  font-size: 0.8125rem;
}

.DriverLogs_filterInputFull__yJ\\+5U {
  width: 100%;
}

.DriverLogs_detailButton__JwDRj {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
}

.DriverLogs_detailIcon__IRbGP {
  width: 1.25rem;
  height: 1.25rem;
}

/* Modal specific */

.DriverLogs_modalTitle__P8EQQ {
  font-size: 1.125rem;
  font-weight: 600;
  color: var(--darkGray);
}

.DriverLogs_closeButton__0fPCB {
  background-color: var(--orange);
  border-color: var(--orange);
  border-radius: 0.25rem;
}

.DriverLogs_closeButton__0fPCB:hover, .DriverLogs_closeButton__0fPCB:focus {
  background-color: var(--orange);
  border-color: var(--orange);
  opacity: 0.8;
}

.DriverLogs_modalContent__lF0Jb {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.DriverLogs_boldText__zQkPV {
  font-weight: 600;
}

.DriverLogs_driverInfoContainer__ZxZVi {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.DriverLogs_driverName__5CI5P {
  font-weight: 600;
  color: var(--darkGray);
}

.DriverLogs_driverSubText__wjdoJ {
  font-size: 0.8125rem;
  color: var(--gray);
}

.DriverLogs_orangeTag__lxbWn {
  border-radius: 0.625rem;
  color: var(--orange);
  border-color: var(--orange);
  background-color: var(--offRed);
}

.DriverLogs_eventDetailsTitle__HzNVO {
  font-weight: 600;
  margin-bottom: 0.75rem;
  font-size: 0.9375rem;
  color: var(--darkGray);
}

.DriverLogs_eventDetailsContainer__4kxMH {
  background-color: #fff;
}

.DriverLogs_jsonKey__f6pSo {
  font-weight: 600;
  color: var(--darkGray);
  text-transform: capitalize;
}

.DriverLogs_jsonPre__N2skW {
  margin: 0;
  padding: 0.75rem;
  background-color: #f9f9f9;
  border-radius: 0.25rem;
  font-size: 0.8125rem;
  overflow-x: auto;
  border: 1px solid #eee;
  color: var(--darkGray);
}

.DriverLogs_jsonValue__h3HrX {
  color: var(--darkGray);
}
`, "",{"version":3,"sources":["webpack://./src/pages/driver-logs/styles/DriverLogs.module.css"],"names":[],"mappings":"AAAA,wBAAwB;;AACxB;EACI,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,qBAAqB;EACrB,yBAAyB;AAC7B;;AAEA;EACI,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACvB;;AAEA;EACI,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACxB;;AAEA;EACI,WAAW;AACf;;AAEA;EACI,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAClB;;AAEA;EACI,cAAc;EACd,eAAe;AACnB;;AAEA,mBAAmB;;AACnB;EACI,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;AAC1B;;AAEA;EACI,+BAA+B;EAC/B,2BAA2B;EAC3B,sBAAsB;AAC1B;;AAEA;EACI,+BAA+B;EAC/B,2BAA2B;EAC3B,YAAY;AAChB;;AAEA;EACI,aAAa;EACb,sBAAsB;EACtB,YAAY;AAChB;;AAEA;EACI,gBAAgB;AACpB;;AAEA;EACI,aAAa;EACb,sBAAsB;EACtB,YAAY;AAChB;;AAEA;EACI,gBAAgB;EAChB,sBAAsB;AAC1B;;AAEA;EACI,oBAAoB;EACpB,kBAAkB;AACtB;;AAEA;EACI,uBAAuB;EACvB,oBAAoB;EACpB,2BAA2B;EAC3B,+BAA+B;AACnC;;AAEA;EACI,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,sBAAsB;AAC1B;;AAEA;EACI,sBAAsB;AAC1B;;AAEA;EACI,gBAAgB;EAChB,sBAAsB;EACtB,0BAA0B;AAC9B;;AAEA;EACI,SAAS;EACT,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;AAC1B;;AAEA;EACI,sBAAsB;AAC1B","sourcesContent":["/* Layout & Containers */\n.filterPanel {\n    background-color: #fff;\n    padding: 1.25rem 1.5rem;\n    border-radius: 0.5rem;\n    margin-bottom: 1.5rem;\n    border: 1px solid #f0f0f0;\n}\n\n.filterTitle {\n    font-size: 1rem;\n    font-weight: 600;\n    color: var(--darkGray);\n    margin-bottom: 1rem;\n}\n\n.filterLabel {\n    margin-bottom: 0.375rem;\n    font-weight: 500;\n    color: var(--gray);\n    font-size: 0.8125rem;\n}\n\n.filterInputFull {\n    width: 100%;\n}\n\n.detailButton {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 0 auto;\n}\n\n.detailIcon {\n    width: 1.25rem;\n    height: 1.25rem;\n}\n\n/* Modal specific */\n.modalTitle {\n    font-size: 1.125rem;\n    font-weight: 600;\n    color: var(--darkGray);\n}\n\n.closeButton {\n    background-color: var(--orange);\n    border-color: var(--orange);\n    border-radius: 0.25rem;\n}\n\n.closeButton:hover, .closeButton:focus {\n    background-color: var(--orange);\n    border-color: var(--orange);\n    opacity: 0.8;\n}\n\n.modalContent {\n    display: flex;\n    flex-direction: column;\n    gap: 1.25rem;\n}\n\n.boldText {\n    font-weight: 600;\n}\n\n.driverInfoContainer {\n    display: flex;\n    flex-direction: column;\n    gap: 0.25rem;\n}\n\n.driverName {\n    font-weight: 600;\n    color: var(--darkGray);\n}\n\n.driverSubText {\n    font-size: 0.8125rem;\n    color: var(--gray);\n}\n\n.orangeTag {\n    border-radius: 0.625rem;\n    color: var(--orange);\n    border-color: var(--orange);\n    background-color: var(--offRed);\n}\n\n.eventDetailsTitle {\n    font-weight: 600;\n    margin-bottom: 0.75rem;\n    font-size: 0.9375rem;\n    color: var(--darkGray);\n}\n\n.eventDetailsContainer {\n    background-color: #fff;\n}\n\n.jsonKey {\n    font-weight: 600;\n    color: var(--darkGray);\n    text-transform: capitalize;\n}\n\n.jsonPre {\n    margin: 0;\n    padding: 0.75rem;\n    background-color: #f9f9f9;\n    border-radius: 0.25rem;\n    font-size: 0.8125rem;\n    overflow-x: auto;\n    border: 1px solid #eee;\n    color: var(--darkGray);\n}\n\n.jsonValue {\n    color: var(--darkGray);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"filterPanel": `DriverLogs_filterPanel__0XBo2`,
	"filterTitle": `DriverLogs_filterTitle__jooGa`,
	"filterLabel": `DriverLogs_filterLabel__CKJPl`,
	"filterInputFull": `DriverLogs_filterInputFull__yJ+5U`,
	"detailButton": `DriverLogs_detailButton__JwDRj`,
	"detailIcon": `DriverLogs_detailIcon__IRbGP`,
	"modalTitle": `DriverLogs_modalTitle__P8EQQ`,
	"closeButton": `DriverLogs_closeButton__0fPCB`,
	"modalContent": `DriverLogs_modalContent__lF0Jb`,
	"boldText": `DriverLogs_boldText__zQkPV`,
	"driverInfoContainer": `DriverLogs_driverInfoContainer__ZxZVi`,
	"driverName": `DriverLogs_driverName__5CI5P`,
	"driverSubText": `DriverLogs_driverSubText__wjdoJ`,
	"orangeTag": `DriverLogs_orangeTag__lxbWn`,
	"eventDetailsTitle": `DriverLogs_eventDetailsTitle__HzNVO`,
	"eventDetailsContainer": `DriverLogs_eventDetailsContainer__4kxMH`,
	"jsonKey": `DriverLogs_jsonKey__f6pSo`,
	"jsonPre": `DriverLogs_jsonPre__N2skW`,
	"jsonValue": `DriverLogs_jsonValue__h3HrX`
};
export default ___CSS_LOADER_EXPORT___;
